import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IGetAllProductReviews,
  IGetAllProductReviewsParams,
  IGetToggleUnuseful,
  IGetToggleUseful,
  postProductReviewData,
} from "./interfaces";

const BaseURL = "/reviews";
const URLs = {
  getReviews: BaseURL,
  toggleUseful: "/toggle-useful",
  toggleUnuseful: "/toggle-unuseful",
  postReview: BaseURL,
};
class ApiProductReviews extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getReviews = (
    params: IGetAllProductReviewsParams,
  ): Promise<IGetAllProductReviews> => this.get(URLs.getReviews, { params });
  postToggleUseful = ({
    reviewId,
  }: {
    reviewId: number;
  }): Promise<IGetToggleUseful> =>
    this.post(`${URLs.getReviews}/${reviewId}${URLs.toggleUseful}`);
  postToggleUnuseful = ({
    reviewId,
  }: {
    reviewId: number;
  }): Promise<IGetToggleUnuseful> =>
    this.post(`${URLs.getReviews}/${reviewId}${URLs.toggleUnuseful}`);
  manageProductReview = (
    body: postProductReviewData,
  ): Promise<IGetToggleUnuseful> => {
    const { review_id } = body;
    delete body.review_id;
    if (review_id)
      return this.put(`${URLs.getReviews}/${review_id}`, {
        ...body,
      });
    else return this.post(URLs.postReview, { ...body });
  };
}
export default ApiProductReviews;
